import { useOutletContext } from 'react-router'

import { FacebookAdAccount, GoogleAdwordsAdAccount } from 'app/connections/types'
import { GoogleAnalyticsAccount } from 'app/connections/types/googleAnalytics'

import CriteoSettings from './CriteoSettings'
import DV360Settings from './DV360Settings'
import FacebookSettings from './FacebookSettings'
import GoogleAdwordsSettings from './GoogleAdwordsSettings'
import GoogleAnalyticsSettings from './GoogleAnalyticsSettings'
import { StepContext } from './StepWithConnectionAndAccounts'

const Settings = <
  A extends FacebookAdAccount | GoogleAdwordsAdAccount | GoogleAnalyticsAccount,
>() => {
  const { connection: connection } = useOutletContext<StepContext<A>>()

  switch (connection.name) {
    case 'criteo':
      return <CriteoSettings />
    case 'dv360':
      return <DV360Settings />
    case 'facebook':
      return <FacebookSettings />
    case 'googleAdwords':
      return <GoogleAdwordsSettings />
    case 'googleAnalytics':
      return <GoogleAnalyticsSettings />

    default:
      return <></>
  }
}

export default Settings
